<template>
  <v-content>

    <Header></Header>

      <v-layout>
        <!-- Menu bar -->
        <template>
          <v-card flat class="main-side-bar">
            <v-navigation-drawer
              class="side-bar"
              v-model="drawer"
              :mini-variant.sync="mini"
              permanent
              height="100%"
            >
              <v-list dense>
                <v-list-item
                  class="sub-side-bar"
                  v-for="item in menuSideBar"
                  :key="item.title"
                  link
                  @click="$router.push(item.route).catch(err => {})"
                >
                  <v-list-item-icon class="pr-0 mr-3">
                    <v-icon class="icon-main-menu" style="font-size: 40px;">{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content style="text-align: left;">
                    <v-list-item-title class="title-nain-menu" style="font-size: 16px; text-overflow: unset;white-space: unset;">
                      {{item.name }}
                    </v-list-item-title>
                  </v-list-item-content>

                </v-list-item>
              </v-list>

              <v-divider></v-divider>

              <v-list-item>
                <v-list-item class="pl-0">
                  <v-btn icon  @click.stop="mini = !mini" v-if="mini">
                    <v-icon v-if="mini" style="font-size: 30px;color: white;">arrow_right</v-icon>
                    <v-icon v-if="!mini" style="font-size: 30px;color: white;">arrow_left</v-icon>
                  </v-btn>
                </v-list-item>

                <v-btn
                  v-if="!mini"
                  icon
                  @click.stop="mini = !mini"
                >
                  <v-icon style="font-size: 30px;color: white;">arrow_left</v-icon>
                </v-btn>
              </v-list-item>

            </v-navigation-drawer>
          </v-card>
        </template>
        <!-- End Menu bar -->

        <!-- Detail -->
        <template>
          <v-content  style="width: calc(100% - 256px);">
            <router-view/>
          </v-content>
        </template>
        <!-- End Detail -->
      </v-layout>

    <v-layout>
      <v-flex class="py-6" style="background-color: white;">
      </v-flex>
    </v-layout>

    <Footer></Footer>

  </v-content>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";

    export default {
        name: "MainLayout",
        components: {
            Footer,
            Header,
        },
        data: () => ({
            // items: [
            //     {title: 'ประวัติการสั่งซื้อ', icon: 'library_books', route: '/manage-user-accounts'},
            //     {title: 'แก้ไขโปรไฟล์', icon: 'edit', route: '/manage-user-accounts'},
            //     {title: 'แก้ไขรหัสผ่าน', icon: 'lock', route: '/manage-user-accounts'},
            //     {title: 'ช่วยเหลือ', icon: 'help', route: '/manage-user-accounts'},
            //     {title: 'ออกจากระบบ', icon: 'exit_to_app', route: '/manage-user-accounts'},
            // ],
            drawer: true,
            mini: false,
            menuSideBar: [
                {
                    name: 'แดชบอร์ด',
                    icon: 'dashboard',
                    route: '/dashboard'
                },
                {
                    name: 'รายงาน',
                    icon: 'folder',
                    route: '/report'
                },
                {
                    name: 'จัดการบัญชีผู้ใช้',
                    icon: 'account_box',
                    route: '/manage-user-accounts'
                },
                {
                    name: 'ข้อมูลคุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์',
                    icon: 'chrome_reader_mode',
                    route: '/data-medical-equipment'
                },
                {
                    name: 'จัดการหน้าช่วยเหลือ',
                    icon: 'add_comment',
                    route: '/manage-help'
                },
            ]
        }),
    }
</script>

<style lang="scss">

</style>
